import React from "react";
import { TextField, Grid } from "@material-ui/core";
import styles from "./ListMasterTagsPage.module.scss";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { getIcon } from "../../../icon/icon";
import { getMasterTags } from "../../../state/actions/ProductActions";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import { withTranslation } from "react-i18next";

class ListMasterTagsPage extends React.Component {
  constructor() {
    super();

    this.state = {
      newTagText: "",
      addTagModalOpen: false,
      originalData: [],
      searchedData: [],
      loading: false,
      masterTags: [],
      selectedGroupIds: []
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.getMasterTags(() => {
      this.setState({ loading: false });
    });

    this.setupData();
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.masterTags) !==
      JSON.stringify(this.props.masterTags)
    ) {
      const data = this.props.masterTags.map(masterTag => {
        return { name: masterTag, id: masterTag };
      });

      this.setState({
        originalData: data,
        searchedData: data,
        masterTags: this.props.masterTags
      });
    }
  }

  setupData() {
    const data = this.props.masterTags.map(masterTag => {
      return { name: masterTag, id: masterTag };
    });

    this.setState({
      originalData: data,
      searchedData: data,
      masterTags: this.props.products
    });
  }

  createHeaders() {
    return [
      {
        id: "name",
        clickable: false,
        align: "left",
        label: this.props.t('master-tag.tag-name')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    if (this.state.searchedData.length === 0) {
      return (
        <PagePlaceholder
          image={getIcon("tag.svg")}
          text={this.props.t('master-tag.none-found')}
        />
      );
    } else {
      return (
        <SimpleTable
          handleSelection={selectedIds => {
            this.setState({ selectedGroupIds: selectedIds });
          }}
          dataId={"id"}
          cells={cells}
          headers={headers}
          rows={this.state.searchedData}
        />
      );
    }
  }

  search(searchText) {
    const text = searchText.toLowerCase();

    if (text === "") {
      this.setState({ searchedData: this.state.originalData });
    }

    const foundData = this.state.originalData.filter(data => {
      return data.name.toLowerCase().includes(text);
    });

    this.setState({ searchedData: foundData });
  }

  render() {

    return (
      <div>
        <HeaderBlock
          title={this.props.t('master-tag.master-tags')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <TextField
                  id="outlined-name"
                  label={this.props.t('master-tag.search')}
                  value={this.state.routeName}
                  onChange={event => this.search(event.target.value)}
                  margin="dense"
                  variant="outlined"
                />
              </Grid>
            </Grid>

          }
        />
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderData()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { masterTags } = state.ProductReducer;
  return { masterTags };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getMasterTags }, dispatch);

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListMasterTagsPage))
);

// EXPORT COMPONENT

export { hoc as ListMasterTagsPage };
